module.exports = __webpack_public_path__ + "static/media/banner-thumbnail.80666545.png";